import BackgroundPane from './BackgroundPane';

export default BackgroundPane;
export { BackgroundPane };
